import React, { useState } from 'react';
import { User, Settings, Bell, Shield, Monitor, Database, Globe, Palette, Save, RefreshCw, Info, Activity, Lock, Eye, EyeOff, Check, AlertTriangle, Download, Upload, ChevronLeft, ChevronRight } from 'lucide-react';

const Configuracion = () => {
  const [activeSection, setActiveSection] = useState('perfil');
  const [showPassword, setShowPassword] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [notifications, setNotifications] = useState({
    email: true,
    push: false,
    sms: true,
    sistema: true
  });
  const [theme, setTheme] = useState('light');
  const [language, setLanguage] = useState('es');
  const [userProfile, setUserProfile] = useState({
    nombre: 'Héctor Gil',
    email: 'hector.gil@empresa.com',
    telefono: '+34 612 345 678',
    cargo: 'Administrador',
    departamento: 'TI'
  });

  const sections = [
    { id: 'perfil', label: 'Perfil de Usuario', icon: User },
    { id: 'sistema', label: 'Sistema', icon: Settings },
    { id: 'notificaciones', label: 'Notificaciones', icon: Bell },
    { id: 'seguridad', label: 'Seguridad', icon: Shield },
    { id: 'apariencia', label: 'Apariencia', icon: Palette },
    { id: 'informacion', label: 'Información', icon: Info }
  ];

  const handleNotificationChange = (type) => {
    setNotifications(prev => ({
      ...prev,
      [type]: !prev[type]
    }));
  };

  const handleProfileChange = (field, value) => {
    setUserProfile(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const renderProfileSection = () => (
    <div className="config-section">
      <div className="section-header">
        <h2>Perfil de Usuario</h2>
        <p>Gestiona tu información personal y configuración de cuenta</p>
      </div>
      <div className="config-grid">
        <div className="config-card">
          <div className="card-header">
            <User size={20} />
            <h3>Información Personal</h3>
          </div>
          <div className="form-group">
            <label>Nombre Completo</label>
            <input
              type="text"
              value={userProfile.nombre}
              onChange={(e) => handleProfileChange('nombre', e.target.value)}
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={userProfile.email}
              onChange={(e) => handleProfileChange('email', e.target.value)}
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label>Teléfono</label>
            <input
              type="tel"
              value={userProfile.telefono}
              onChange={(e) => handleProfileChange('telefono', e.target.value)}
              className="form-input"
            />
          </div>
        </div>
      </div>
      <div className="action-buttons">
        <button className="btn btn-primary">
          <Save size={16} />
          Guardar Cambios
        </button>
        <button className="btn btn-secondary">
          <RefreshCw size={16} />
          Restablecer
        </button>
      </div>
    </div>
  );

  const renderSistemaSection = () => (
    <div className="config-section">
      <div className="section-header">
        <h2>Configuración del Sistema</h2>
        <p>Ajustes generales y configuración técnica</p>
      </div>
      <div className="config-grid">
        <div className="config-card">
          <div className="card-header">
            <Globe size={20} />
            <h3>Idioma y Región</h3>
          </div>
          <div className="form-group">
            <label>Idioma</label>
            <select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              className="form-select"
            >
              <option value="es">Español</option>
              <option value="en">English</option>
              <option value="fr">Français</option>
              <option value="pt">Português</option>
            </select>
          </div>
          <div className="form-group">
            <label>Zona Horaria</label>
            <select className="form-select">
              <option value="Europe/Madrid">Madrid (UTC+1)</option>
              <option value="Europe/London">Londres (UTC+0)</option>
              <option value="America/New_York">Nueva York (UTC-5)</option>
            </select>
          </div>
        </div>
        <div className="config-card">
          <div className="card-header">
            <Database size={20} />
            <h3>Base de Datos</h3>
          </div>
          <div className="status-item">
            <div className="status-info">
              <span>Estado de Conexión</span>
              <div className="status-indicator online">Conectado</div>
            </div>
          </div>
          <div className="status-item">
            <div className="status-info">
              <span>Última Sincronización</span>
              <span className="status-time">Hace 2 minutos</span>
            </div>
          </div>
          <button className="btn btn-outline">
            <RefreshCw size={16} />
            Sincronizar Ahora
          </button>
        </div>
      </div>
    </div>
  );

  const renderNotificacionesSection = () => (
    <div className="config-section">
      <div className="section-header">
        <h2>Configuración de Notificaciones</h2>
        <p>Controla cómo y cuándo recibes notificaciones</p>
      </div>
      <div className="config-grid">
        <div className="config-card">
          <div className="card-header">
            <Bell size={20} />
            <h3>Tipos de Notificación</h3>
          </div>
          <div className="notification-options">
            <div className="notification-item">
              <div className="notification-info">
                <span>Notificaciones por Email</span>
                <small>Recibe alertas importantes por correo</small>
              </div>
              <label className="toggle">
                <input
                  type="checkbox"
                  checked={notifications.email}
                  onChange={() => handleNotificationChange('email')}
                />
                <span className="slider"></span>
              </label>
            </div>
            <div className="notification-item">
              <div className="notification-info">
                <span>Notificaciones Push</span>
                <small>Alertas en tiempo real en el navegador</small>
              </div>
              <label className="toggle">
                <input
                  type="checkbox"
                  checked={notifications.push}
                  onChange={() => handleNotificationChange('push')}
                />
                <span className="slider"></span>
              </label>
            </div>
            <div className="notification-item">
              <div className="notification-info">
                <span>Mensajes SMS</span>
                <small>Alertas críticas por mensaje de texto</small>
              </div>
              <label className="toggle">
                <input
                  type="checkbox"
                  checked={notifications.sms}
                  onChange={() => handleNotificationChange('sms')}
                />
                <span className="slider"></span>
              </label>
            </div>
            <div className="notification-item">
              <div className="notification-info">
                <span>Alertas del Sistema</span>
                <small>Notificaciones de estado y mantenimiento</small>
              </div>
              <label className="toggle">
                <input
                  type="checkbox"
                  checked={notifications.sistema}
                  onChange={() => handleNotificationChange('sistema')}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderSeguridadSection = () => (
    <div className="config-section">
      <div className="section-header">
        <h2>Seguridad</h2>
        <p>Gestiona la seguridad de tu cuenta y datos</p>
      </div>
      <div className="config-grid">
        <div className="config-card">
          <div className="card-header">
            <Lock size={20} />
            <h3>Cambiar Contraseña</h3>
          </div>
          <div className="form-group">
            <label>Contraseña Actual</label>
            <div className="password-input">
              <input
                type={showPassword ? 'text' : 'password'}
                className="form-input"
                placeholder="Ingresa tu contraseña actual"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="password-toggle"
              >
                {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label>Nueva Contraseña</label>
            <input
              type="password"
              className="form-input"
              placeholder="Nueva contraseña"
            />
          </div>
          <div className="form-group">
            <label>Confirmar Contraseña</label>
            <input
              type="password"
              className="form-input"
              placeholder="Confirma la nueva contraseña"
            />
          </div>
          <button className="btn btn-primary">
            Actualizar Contraseña
          </button>
        </div>
        <div className="config-card">
          <div className="card-header">
            <Shield size={20} />
            <h3>Seguridad de la Cuenta</h3>
          </div>
          <div className="security-options">
            <div className="security-item">
              <div className="security-info">
                <span>Autenticación de Dos Factores</span>
                <small>Agrega una capa extra de seguridad</small>
              </div>
              <button className="btn btn-outline">Configurar</button>
            </div>
            <div className="security-item">
              <div className="security-info">
                <span>Sesiones Activas</span>
                <small>3 dispositivos conectados</small>
              </div>
              <button className="btn btn-outline">Ver Sesiones</button>
            </div>
            <div className="security-item">
              <div className="security-info">
                <span>Historial de Acceso</span>
                <small>Último acceso: Hoy 14:30</small>
              </div>
              <button className="btn btn-outline">Ver Historial</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderAparienciaSection = () => (
    <div className="config-section">
      <div className="section-header">
        <h2>Apariencia</h2>
        <p>Personaliza la interfaz según tus preferencias</p>
      </div>
      <div className="config-grid">
        <div className="config-card">
          <div className="card-header">
            <Palette size={20} />
            <h3>Tema</h3>
          </div>
          <div className="theme-options">
            <div className="theme-grid">
              <div
                className={`theme-option ${theme === 'light' ? 'active' : ''}`}
                onClick={() => setTheme('light')}
              >
                <div className="theme-preview light">
                  <div className="theme-header"></div>
                  <div className="theme-sidebar"></div>
                  <div className="theme-content"></div>
                </div>
                <span>Claro</span>
              </div>
              <div
                className={`theme-option ${theme === 'dark' ? 'active' : ''}`}
                onClick={() => setTheme('dark')}
              >
                <div className="theme-preview dark">
                  <div className="theme-header"></div>
                  <div className="theme-sidebar"></div>
                  <div className="theme-content"></div>
                </div>
                <span>Oscuro</span>
              </div>
              <div
                className={`theme-option ${theme === 'auto' ? 'active' : ''}`}
                onClick={() => setTheme('auto')}
              >
                <div className="theme-preview auto">
                  <div className="theme-header"></div>
                  <div className="theme-sidebar"></div>
                  <div className="theme-content"></div>
                </div>
                <span>Automático</span>
              </div>
            </div>
          </div>
        </div>
        <div className="config-card">
          <div className="card-header">
            <Monitor size={20} />
            <h3>Diseño</h3>
          </div>
          <div className="form-group">
            <label>Tamaño de Fuente</label>
            <select className="form-select">
              <option value="small">Pequeño</option>
              <option value="medium">Mediano</option>
              <option value="large">Grande</option>
            </select>
          </div>
          <div className="form-group">
            <label>Densidad de Interfaz</label>
            <select className="form-select">
              <option value="compact">Compacta</option>
              <option value="comfortable">Cómoda</option>
              <option value="spacious">Espaciosa</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );

  const renderInformacionSection = () => (
    <div className="config-section">
      <div className="section-header">
        <h2>Información del Sistema</h2>
        <p>Detalles técnicos y estado del sistema</p>
      </div>
      <div className="config-grid">
        <div className="config-card">
          <div className="card-header">
            <Info size={20} />
            <h3>Información General</h3>
          </div>
          <div className="info-list">
            <div className="info-item">
              <span className="info-label">Versión del Sistema</span>
              <span className="info-value">v2.1.4</span>
            </div>
            <div className="info-item">
              <span className="info-label">Última Actualización</span>
              <span className="info-value">15 Agosto 2025</span>
            </div>
            <div className="info-item">
              <span className="info-label">Licencia</span>
              <span className="info-value">Empresarial Pro</span>
            </div>
            <div className="info-item">
              <span className="info-label">Soporte Técnico</span>
              <span className="info-value">24/7 Disponible</span>
            </div>
          </div>
        </div>
        <div className="config-card">
          <div className="card-header">
            <Activity size={20} />
            <h3>Estado del Sistema</h3>
          </div>
          <div className="status-grid">
            <div className="status-card">
              <div className="status-icon online">
                <Check size={16} />
              </div>
              <div className="status-details">
                <span className="status-title">Servicios Web</span>
                <span className="status-subtitle">Operativo</span>
              </div>
            </div>
            <div className="status-card">
              <div className="status-icon online">
                <Check size={16} />
              </div>
              <div className="status-details">
                <span className="status-title">Base de Datos</span>
                <span className="status-subtitle">Conectada</span>
              </div>
            </div>
            <div className="status-card">
              <div className="status-icon warning">
                <AlertTriangle size={16} />
              </div>
              <div className="status-details">
                <span className="status-title">Respaldo</span>
                <span className="status-subtitle">Pendiente</span>
              </div>
            </div>
            <div className="status-card">
              <div className="status-icon online">
                <Check size={16} />
              </div>
              <div className="status-details">
                <span className="status-title">Seguridad</span>
                <span className="status-subtitle">Protegido</span>
              </div>
            </div>
          </div>
        </div>
        <div className="config-card">
          <div className="card-header">
            <Download size={20} />
            <h3>Mantenimiento</h3>
          </div>
          <div className="maintenance-actions">
            <button className="btn btn-outline">
              <Download size={16} />
              Descargar Logs
            </button>
            <button className="btn btn-outline">
              <Upload size={16} />
              Exportar Configuración
            </button>
            <button className="btn btn-outline">
              <RefreshCw size={16} />
              Limpiar Caché
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  const renderActiveSection = () => {
    switch (activeSection) {
      case 'perfil':
        return renderProfileSection();
      case 'sistema':
        return renderSistemaSection();
      case 'notificaciones':
        return renderNotificacionesSection();
      case 'seguridad':
        return renderSeguridadSection();
      case 'apariencia':
        return renderAparienciaSection();
      case 'informacion':
        return renderInformacionSection();
      default:
        return renderProfileSection();
    }
  };

  return (
    <div className="configuracion-container">
      <div className={`sidebar ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <div className="sidebar-header">
          <div className="logo">
            <div className="logo-icon">
              <Settings className="icon" />
            </div>
            <div className="logo-text">
              <h1>Configuración</h1>
              <p>Panel de Control</p>
            </div>
          </div>
          <button
            className="toggle-sidebar-button"
            onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
          >
            {isSidebarCollapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
          </button>
        </div>
        <nav className="sidebar-nav">
          {sections.map((section) => (
            <button
              key={section.id}
              onClick={() => setActiveSection(section.id)}
              className={`nav-item ${activeSection === section.id ? 'active' : ''}`}
            >
              <section.icon className="nav-icon" />
              <span>{section.label}</span>
            </button>
          ))}
        </nav>
      </div>

      <div className="config-content">
        {renderActiveSection()}
      </div>

      <style jsx>{`
        .configuracion-container {
          min-height: 100vh;
          background: #f8fafc;
          display: flex;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }

        .sidebar {
          width: 280px;
          background: linear-gradient(180deg, #1a202c 0%, #2d3748 100%);
          display: flex;
          flex-direction: column;
          position: sticky;
          top: 0;
          height: 100vh;
          overflow-y: auto;
          transition: width 0.3s ease;
          flex-shrink: 0;
          z-index: 10;
        }

        .sidebar.collapsed {
          width: 70px;
        }

        .sidebar-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 16px;
          min-height: 80px;
        }

        .sidebar.collapsed .sidebar-header {
          justify-content: center;
          padding: 10px 10px;
        }

        .logo {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .logo-icon {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        }

        .logo-icon .icon {
          color: white;
          width: 22px;
          height: 22px;
        }

        .logo-text {
          overflow: hidden;
        }

        .sidebar.collapsed .logo-text {
          display: none;
        }

        .logo-text h1 {
          color: white;
          font-size: 18px;
          font-weight: 700;
          margin: 0 0 2px 0;
        }

        .logo-text p {
          color: #a0aec0;
          font-size: 13px;
          margin: 0;
        }

        .toggle-sidebar-button {
          background: none;
          border: none;
          cursor: pointer;
          padding: 8px;
          border-radius: 6px;
          transition: background 0.3s ease;
          color: #94a3b8;
        }

        .toggle-sidebar-button:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .sidebar-nav {
          display: flex;
          flex-direction: column;
          gap: 4px;
          padding: 8px 16px;
          flex: 1;
        }

        .nav-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 16px;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s ease;
          border: none;
          background: none;
          color: #a0aec0;
          font-size: 14px;
          font-weight: 500;
          text-align: left;
          position: relative;
        }

        .nav-icon {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }

        .sidebar.collapsed .nav-item {
          justify-content: center;
          padding: 12px 8px;
        }

        .sidebar.collapsed .nav-item span {
          display: none;
        }

        .nav-item:hover {
          background: rgba(255, 255, 255, 0.1);
          color: white;
        }

        .nav-item.active {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        }

        .notification-badge {
          position: absolute;
          top: 6px;
          right: 6px;
          background: #ef4444;
          color: white;
          border-radius: 50%;
          width: 18px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 11px;
          font-weight: 600;
        }

        .config-content {
          flex: 1;
          padding: 32px;
          overflow-y: auto;
        }

        .config-section {
          max-width: none;
          animation: fadeIn 0.3s ease-out;
        }

        .section-header {
          margin-bottom: 32px;
        }

        .section-header h2 {
          font-size: 24px;
          font-weight: 700;
          color: #1a202c;
          margin: 0 0 8px 0;
        }

        .section-header p {
          color: #718096;
          margin: 0;
          font-size: 14px;
        }

        .config-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
          gap: 24px;
          margin-bottom: 32px;
        }

        .config-card {
          background: white;
          border-radius: 12px;
          padding: 24px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .config-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .card-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
        }

        .card-header h3 {
          font-size: 18px;
          font-weight: 600;
          color: #2d3748;
          margin: 0;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          display: block;
          font-size: 14px;
          font-weight: 500;
          color: #374151;
          margin-bottom: 8px;
        }

        .form-input {
          width: 100%;
          padding: 12px;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          font-size: 14px;
          transition: border-color 0.2s ease;
          background: white;
          box-sizing: border-box;
        }

        .form-input:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .form-select {
          width: 100%;
          padding: 12px;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          font-size: 14px;
          background: white;
          cursor: pointer;
          box-sizing: border-box;
        }

        .password-input {
          position: relative;
        }

        .password-toggle {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          border: none;
          background: transparent;
          color: #6b7280;
          cursor: pointer;
          padding: 4px;
        }

        .action-buttons {
          display: flex;
          gap: 12px;
          justify-content: flex-start;
        }

        .btn {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 12px 20px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          border: none;
        }

        .btn-primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
        }

        .btn-primary:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        }

        .btn-secondary {
          background: #f7fafc;
          color: #4a5568;
          border: 1px solid #e2e8f0;
        }

        .btn-secondary:hover {
          background: #edf2f7;
        }

        .btn-outline {
          background: transparent;
          color: #667eea;
          border: 1px solid #667eea;
          padding: 8px 16px;
        }

        .btn-outline:hover {
          background: #667eea;
          color: white;
        }

        .status-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 0;
          border-bottom: 1px solid #e2e8f0;
        }

        .status-item:last-child {
          border-bottom: none;
        }

        .status-indicator {
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 500;
        }

        .status-indicator.online {
          background: #d1fae5;
          color: #065f46;
        }

        .status-time {
          color: #6b7280;
          font-size: 14px;
        }

        .notification-options {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .notification-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px;
          background: #f8fafc;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
        }

        .notification-info span {
          display: block;
          font-weight: 500;
          color: #1f2937;
          margin-bottom: 4px;
        }

        .notification-info small {
          color: #6b7280;
          font-size: 13px;
        }

        .toggle {
          position: relative;
          display: inline-block;
          width: 44px;
          height: 24px;
        }

        .toggle input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #cbd5e0;
          transition: 0.3s;
          border-radius: 24px;
        }

        .slider:before {
          position: absolute;
          content: "";
          height: 18px;
          width: 18px;
          left: 3px;
          bottom: 3px;
          background-color: white;
          transition: 0.3s;
          border-radius: 50%;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        input:checked + .slider {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }

        input:checked + .slider:before {
          transform: translateX(20px);
        }

        .security-options {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .security-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px;
          background: #f8fafc;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
        }

        .security-info span {
          display: block;
          font-weight: 500;
          color: #1f2937;
          margin-bottom: 4px;
        }

        .security-info small {
          color: #6b7280;
          font-size: 13px;
        }

        .theme-options {
          padding: 4px 0;
        }

        .theme-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
          gap: 16px;
        }

        .theme-option {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          padding: 16px;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s ease;
          border: 2px solid transparent;
        }

        .theme-option:hover {
          background: #f7fafc;
        }

        .theme-option.active {
          border-color: #667eea;
          background: #f0f9ff;
        }

        .theme-preview {
          width: 80px;
          height: 60px;
          border-radius: 6px;
          position: relative;
          overflow: hidden;
          border: 1px solid #e2e8f0;
        }

        .theme-preview.light {
          background: #ffffff;
        }

        .theme-preview.dark {
          background: #1a202c;
        }

        .theme-preview.auto {
          background: linear-gradient(45deg, #ffffff 50%, #1a202c 50%);
        }

        .theme-header {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 12px;
          background: #667eea;
        }

        .theme-sidebar {
          position: absolute;
          left: 0;
          top: 12px;
          bottom: 0;
          width: 20px;
          background: #4a5568;
        }

        .theme-content {
          position: absolute;
          left: 20px;
          top: 12px;
          right: 4px;
          bottom: 4px;
          background: #f7fafc;
          border-radius: 2px;
        }

        .theme-preview.dark .theme-content {
          background: #2d3748;
        }

        .theme-option span {
          font-size: 13px;
          font-weight: 500;
          color: #4a5568;
        }

        .info-list {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .info-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 0;
          border-bottom: 1px solid #e2e8f0;
        }

        .info-item:last-child {
          border-bottom: none;
        }

        .info-label {
          font-weight: 500;
          color: #4a5568;
        }

        .info-value {
          font-weight: 600;
          color: #1a202c;
        }

        .status-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 16px;
        }

        .status-card {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 16px;
          background: #f8fafc;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .status-card:hover {
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .status-icon {
          width: 32px;
          height: 32px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .status-icon.online {
          background: #d1fae5;
          color: #059669;
        }

        .status-icon.warning {
          background: #fef3c7;
          color: #d97706;
        }

        .status-icon.error {
          background: #fee2e2;
          color: #dc2626;
        }

        .status-details {
          flex: 1;
        }

        .status-title {
          display: block;
          font-weight: 500;
          color: #1f2937;
          margin-bottom: 2px;
        }

        .status-subtitle {
          font-size: 13px;
          color: #6b7280;
        }

        .maintenance-actions {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .configuracion-container {
            flex-direction: column;
          }

          .sidebar {
            position: static;
            width: 100%;
            height: auto;
          }

          .sidebar-header {
            justify-content: space-between;
          }

          .sidebar-nav {
            flex-direction: row;
            overflow-x: auto;
            padding: 8px 16px 16px 16px;
          }

          .nav-item {
            white-space: nowrap;
            min-width: fit-content;
          }

          .config-grid {
            grid-template-columns: 1fr;
          }

          .config-content {
            padding: 20px;
          }
        }

        @media (max-width: 768px) {
          .config-content {
            padding: 16px;
          }

          .section-header h2 {
            font-size: 20px;
          }

          .theme-grid {
            grid-template-columns: repeat(3, 1fr);
          }

          .status-grid {
            grid-template-columns: 1fr;
          }

          .action-buttons {
            flex-direction: column;
          }

          .btn {
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .section-header h2 {
            font-size: 18px;
          }

          .card-header h3 {
            font-size: 16px;
          }

          .form-input, .form-select {
            padding: 10px;
            font-size: 13px;
          }

          .btn {
            padding: 10px 16px;
            font-size: 13px;
          }

          .notification-item, .security-item, .status-card {
            padding: 12px;
          }

          .config-card {
            padding: 16px;
          }

          .theme-preview {
            width: 60px;
            height: 45px;
          }
        }

        /* Estados de focus mejorados */
        .form-input:focus,
        .form-select:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .nav-item:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .btn:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
        }

        .toggle input:focus + .slider {
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
        }

        .theme-option:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
        }

        /* Estados disabled */
        .btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          transform: none;
        }

        .form-input:disabled,
        .form-select:disabled {
          background-color: #f9fafb;
          color: #9ca3af;
          cursor: not-allowed;
        }

        /* Scrollbar personalizado */
        .sidebar-nav::-webkit-scrollbar {
          height: 4px;
        }

        .sidebar-nav::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 2px;
        }

        .sidebar-nav::-webkit-scrollbar-thumb {
          background: #cbd5e0;
          border-radius: 2px;
        }

        .sidebar-nav::-webkit-scrollbar-thumb:hover {
          background: #a0aec0;
        }
      `}</style>
    </div>
  );
};

export default Configuracion;